
// Development configuration

const firebaseDevelopmentConfig = {
  apiKey: 'AIzaSyBsXB1_bti9dGxSiKZTfTl_8fRl9-QY_cI',
  authDomain: 'ecoin-f9c5c.firebaseapp.com',
  databaseURL: 'https://ecoin-f9c5c.firebaseio.com',
  projectId: 'ecoin-f9c5c',
  storageBucket: 'ecoin-f9c5c.appspot.com',
  messagingSenderId: '603332537782',
  appId: '1:603332537782:web:235a1f8774925cb97f2517',
  measurementId: 'G-492843P2KJ'
}

export {
  firebaseDevelopmentConfig
}

